import React, { useState, useEffect } from "react";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Col,
  Modal,
  Button,
  Form,
  Card,
  FormCheck,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Pagination from "../../components/Pagination";

function WidgetsList() {

    const navigate = useNavigate();

  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [loader, setLoader] = useState(false);
  const [widgets, setWidgets] = useState([]);
  const [search, SetSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [addModalShow, SetAddModalShow] = useState(false);
  const [widgetAddToDb, setWidgetAddToDb] = useState({
    WidgetId: 0,
    WidgetName: "",
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [widgetUpdateToDb, setWidgetUpdateToDb] = useState({
    WidgetId: 0,
    WidgetName: "",
  });
  const [updateModalShow, setUpdateModalShow] = useState(0);

  // Get Widgets
  const GetWidgets = async () => {
    setLoader(true);
    let response = await fetch(Variables.API_URL + `Widget/GetWidgets?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    
    if (response.status === 200) {
      setWidgets(result.Items);
      setFilteredData(result.Items);
      setTotalCount(result.TotalCount);
    }
    setLoader(false);
  };

  // handle Search
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    SetSearch(value);
    result = widgets.filter((data) => {
      return data.WidgetName.toLowerCase().search(value) !== -1;
    });
    setFilteredData(result);
  };

  // Clear Widget Add To Db
  function ClearWidgetAddToDb() {
    SetAddModalShow(false);
    setWidgetAddToDb({
        WidgetId: 0,
        WidgetName: "",
    });
  }

  // Set Add To Db
  function SetAddToDb() {
    SetAddModalShow(true);
    setWidgetAddToDb({
        WidgetId: 0,
        WidgetName: "",
    });
  }

  // Clear Widget Update To Db
  function ClearWidgetUpdateToDb() {
    setUpdateModalShow(0);
    setWidgetUpdateToDb({
        WidgetId: 0,
        WidgetName: "",
    });
  }

  // handle Add Inputs
  function handleAddInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("WidgetNameToAdd");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("WidgetNameToAdd");
      element.classList.remove("is-invalid");
    }
    setWidgetAddToDb((prevState) => ({
      ...prevState,
      ["WidgetName"]: value,
    }));
  }

  // Check input validity
  function IsValidToAdd() {
    var hasError = false;
    var element;
    if (
      widgetAddToDb.WidgetName === null ||
      widgetAddToDb.WidgetName === ""
    ) {
      element = document.getElementById("WidgetNameToAdd");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Widget
  const AddNewWidget = async () => {
    var Valid = IsValidToAdd();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "Widget/AddNewWidget",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            WidgetId: widgetAddToDb.WidgetId,
            WidgetName: widgetAddToDb.WidgetName,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        SetAddModalShow(false);
        setWidgetAddToDb({
            WidgetId: 0,
            WidgetName: "",
        });
        GetWidgets();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select Widget Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // handle Updatee Inputs
  function handleUpdateInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("WidgetNameToUpdate");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("WidgetNameToUpdate");
      element.classList.remove("is-invalid");
    }
    setWidgetUpdateToDb((prevState) => ({
      ...prevState,
      ["WidgetName"]: value,
    }));
  }

  // Check input validity
  function IsValidToUpdate() {
    var hasError = false;
    var element;
    if (
      widgetUpdateToDb.WidgetName === null ||
      widgetUpdateToDb.WidgetName === ""
    ) {
      element = document.getElementById("WidgetNameToUpdate");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Update Widget
  const UpdateWidget = async () => {
    var Valid = IsValidToUpdate();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "Widget/UpdateWidget",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            WidgetId: widgetUpdateToDb.WidgetId,
            WidgetName: widgetUpdateToDb.WidgetName,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setUpdateModalShow(0);
        setWidgetUpdateToDb({
            WidgetId: 0,
            WidgetName: "",
        });
        GetWidgets();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select Widget Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    if(Permissions.ViewWidgets === false){
      navigate("/");
    }
    GetWidgets();
  }, [pageNumber, pageSize]);

  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Widgets List</h4>
              </div>
              {Permissions.ManageWidgets === true && <Button variant="primary" onClick={() => SetAddToDb()}>
                Add New Widget
              </Button>}
              
            </Card.Header>
            <Card.Body className="px-0">
              <Form.Control
                id="Search"
                name="Search"
                placeholder="Search"
                type="text"
                className="allignCenter"
                onChange={handleSearch}
              />
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th></th>
                        <th>Widget Name</th>
                        <th min-width="100px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((tdata, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td>{tdata.WidgetName}</td>
                          <td>
                            {Permissions.ManageWidgets === true && <div className="flex align-items-center list-user-action">
                              <Link
                                className="btn btn-sm btn-icon btn-success"
                                data-toggle="tooltip"
                                data-placement="top"
                                title=""
                                data-original-title="Edit"
                                to={"#"}
                                onClick={() => {
                                  setWidgetUpdateToDb({
                                    WidgetId: tdata.WidgetId,
                                    WidgetName: tdata.WidgetName,
                                  });
                                  setUpdateModalShow(tdata.WidgetId);
                                }}
                              >
                                <span className="btn-inner">
                                  <svg
                                    width="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M15.1655 4.60254L19.7315 9.16854"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </span>
                              </Link>{" "}
                              <Modal
                                show={updateModalShow == tdata.WidgetId}
                                onHide={() => ClearWidgetUpdateToDb()}
                              >
                                <Modal.Header closeButton>
                                  <Modal.Title as="h5">
                                    Update Direction :{" "}
                                    {widgetUpdateToDb.WidgetName}
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row>
                                    <Form.Group className="col-md-12 form-group">
                                      <Form.Label htmlFor="lname">
                                        Widget Name:
                                      </Form.Label>
                                      <Form.Control
                                        id="WidgetNameToUpdate"
                                        name="WidgetNameToUpdate"
                                        placeholder="Widget Name"
                                        type="text"
                                        value={widgetUpdateToDb.WidgetName}
                                        onChange={handleUpdateInputs}
                                      />
                                    </Form.Group>
                                  </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="secondary"
                                    onClick={() => setUpdateModalShow(0)}
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    variant="primary"
                                    onClick={() => UpdateWidget()}
                                  >
                                    Save changes
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </div>}
                            
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    pageNumber={pageNumber}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPageNumber(newPage)}
                  />

                  <Modal
                    show={addModalShow}
                    onHide={() => ClearWidgetAddToDb()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title as="h5">Add New Widget</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">Widget Name:</Form.Label>
                          <Form.Control
                            id="WidgetNameToAdd"
                            name="WidgetNameToAdd"
                            placeholder="Widget Name"
                            type="text"
                            value={widgetAddToDb.WidgetName}
                            onChange={handleAddInputs}
                          />
                        </Form.Group>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => SetAddModalShow(false)}
                      >
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => AddNewWidget()}
                      >
                        Save changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

export default WidgetsList